import { render, staticRenderFns } from "./RoomManage.vue?vue&type=template&id=711242bd&"
import script from "./RoomManage.vue?vue&type=script&lang=js&"
export * from "./RoomManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports